import { parseValorMonetarioBr } from './validacaoDespesaFornecedor'

function hasFormaPagamentoSelecionada(pag) {
  const fp = pag?.formaPagamento
  if (fp == null || fp === '') return false
  if (typeof fp === 'number' || typeof fp === 'string') {
    return Number(fp) > 0
  }
  const v = fp.value
  if (v === null || v === undefined || v === '') return false
  if (Number(v) === 0) return false
  const lab = String(fp.label || '')
  if (/selecione/i.test(lab)) return false
  return true
}

/** Alinha valor da linha com pagamentos quando o usuário informou o total mas não salvou valor nas linhas do modal. */
export function prepararPagamentosAdiantamento(item) {
  const valorLinha = parseValorMonetarioBr(item?.valor)
  let pagamentos = Array.isArray(item?.pagamentos) ? [...item.pagamentos] : []

  if (pagamentos.length === 0 && valorLinha > 0) {
    return [{
      valor: item?.valor ?? String(valorLinha),
      formaPagamento: { label: 'Selecione a forma de pagamento!', value: '' },
      banco: { label: 'Selecione um banco!', value: 0 },
      parcela: { label: '1X', value: 1 },
      fontePagamento: { label: 'Selecione a fonte de pagamento!', value: 0 },
    }]
  }

  const somaPagamentos = pagamentos.reduce(
    (acc, pag) => acc + parseValorMonetarioBr(pag?.valor),
    0
  )

  if (valorLinha > 0 && somaPagamentos < 0.001 && pagamentos.length > 0) {
    pagamentos = pagamentos.map((pag, index) => (
      index === 0
        ? { ...pag, valor: item?.valor != null ? String(item.valor) : String(valorLinha) }
        : pag
    ))
  }

  return pagamentos
}

export function getTotalPagoAdiantamento(item) {
  const pagamentos = prepararPagamentosAdiantamento(item)
  return pagamentos.reduce((acc, pag) => {
    if (!hasFormaPagamentoSelecionada(pag)) return acc
    return acc + parseValorMonetarioBr(pag?.valor)
  }, 0)
}

export function adiantamentoReembolsoTemPagamentoValido(item) {
  const valorLinha = parseValorMonetarioBr(item?.valor)
  if (valorLinha <= 0) return true

  const tipoId = item?.adiantamento_reembolso_tipo_id
  const tipoLegado = item?.tipo
  const temTipo = (tipoId != null && tipoId !== '') || (tipoLegado && String(tipoLegado).trim() !== '')
  if (!temTipo) return false

  const pagamentos = prepararPagamentosAdiantamento(item)
  return pagamentos.some(
    (pag) => hasFormaPagamentoSelecionada(pag) && parseValorMonetarioBr(pag?.valor) > 0
  )
}

export function adiantamentoReembolsoPagamentoCompleto(item) {
  const valorLinha = parseValorMonetarioBr(item?.valor)
  if (valorLinha <= 0) return true
  if (!adiantamentoReembolsoTemPagamentoValido(item)) return false
  const totalPago = getTotalPagoAdiantamento(item)
  return totalPago >= valorLinha - 0.01
}
